import axios from "axios";
import React, { createContext } from "react";

export const AppContext = createContext();
export const AppProvider = ({ children }) => {
  const [categories, setCategories] = React.useState(() => {
    try {
      const cached = localStorage.getItem("map_cache_categories");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [favourites, setFavourites] = React.useState([]);
  const [topCategories, setTopCategories] = React.useState(() => {
    try {
      const cached = localStorage.getItem("map_cache_top_categories");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [brands, setBrands] = React.useState(() => {
    try {
      const cached = localStorage.getItem("map_cache_brands");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [conditions, setConditions] = React.useState(() => {
    try {
      const cached = localStorage.getItem("map_cache_conditions");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [searchedAdverts, setSearchedAdverts] = React.useState([]);
  const [display, setdisplay] = React.useState(false);
  const [reload, setReload] = React.useState(false);
  const [reset, setReset] = React.useState(false);
  const [searchtitle, setsearchtitle] = React.useState("");

  const [searchedMechanics, setSearchedMechanics] = React.useState([]);
  const [searchedTowTrucks, setSearchedTowTrucks] = React.useState([]);
  const [specialties, setSpecialties] = React.useState(() => {
    try {
      const cached = localStorage.getItem("map_cache_specialties");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });

  const [coordinates, setCoordinates] = React.useState({
    lat: null,
    lng: null,
  });

  React.useEffect(() => {
    const reset = () => {
      setsearchtitle("");
      setSearchedAdverts([]);
    };
    reset();
  }, [reset]);

  React.useEffect(() => {
    axios
      .get("https://dashboard.maineautoparts.com/api/categories")
      .then((response) => {
        const top = response.data.slice(0, 3);
        setCategories(response.data);
        setTopCategories(top);
        try {
          localStorage.setItem("map_cache_categories", JSON.stringify(response.data));
          localStorage.setItem("map_cache_top_categories", JSON.stringify(top));
        } catch (e) {}
      })
      .catch((err) => console.log("Categories fetch error:", err));

    axios
      .get("https://dashboard.maineautoparts.com/api/brands")
      .then((response) => {
        const brandData = response.data.data || [];
        setBrands(brandData);
        try {
          localStorage.setItem("map_cache_brands", JSON.stringify(brandData));
        } catch (e) {}
      })
      .catch((err) => console.log("Brands fetch error:", err));

    axios
      .get("https://dashboard.maineautoparts.com/api/conditions")
      .then((response) => {
        const condData = response.data.data || [];
        setConditions(condData);
        try {
          localStorage.setItem("map_cache_conditions", JSON.stringify(condData));
        } catch (e) {}
      })
      .catch((err) => console.log("Conditions fetch error:", err));

    axios
      .get("https://dashboard.maineautoparts.com/api/specialties")
      .then((response) => {
        const specData = Array.isArray(response.data.data) ? response.data.data : [];
        setSpecialties(specData);
        try {
          localStorage.setItem("map_cache_specialties", JSON.stringify(specData));
        } catch (e) {}
      })
      .catch((err) => console.log("Specialties fetch error:", err));
    const getFavourites = () => {
      let user = localStorage.getItem(
        "xompsmpsnd101010299msiknsloa11292nsinsi"
      );
      user = JSON.parse(user);
      if (user == null) {
        return false;
      }
      axios({
        method: "get",
        url: "https://dashboard.maineautoparts.com/api/allFavourites",
        headers: {
          Authorization: `Bearer ${user.accessToken}`,
        },
      }).then((response) => {
        let ads = response.data.data;
        setFavourites(ads);
      });
    };
    getFavourites();
  }, []);
  const searchAds = (category, brand, minPrice, maxPrice, title) => {
    setdisplay(true);
    axios
      .get(
        `https://dashboard.maineautoparts.com/api/search-adverts?featured=0&category_id=${category}&brand_id=${brand}&dealer_id&minimumPrice=${minPrice}&maximumPrice=${maxPrice}&search=${title}`
        //`https://dashboard.maineautoparts.com/api/search-adverts?featured=0&category_id=${category}&brand_id=${brand}&dealer_id&minimumPrice=${minPrice}&maximumPrice=${maxPrice}&search=${title}`
      )
      .then((response) => {
        let ads = response.data.data;
        setSearchedAdverts(ads);
        setdisplay(false);
        setsearchtitle(title);
      });
  };

  const searchMechanics = (specialty, address, latitude, longitude) => {
    setdisplay(true);

    const doSearch = (lat, lng) => {
      axios
        .post("https://dashboard.maineautoparts.com/api/mechanics", {
          specialty,
          address,
          latitude: lat,
          longitude: lng,
        })
        .then((response) => {
          setSearchedMechanics(Array.isArray(response.data.data) ? response.data.data : []);
          setdisplay(false);
          setsearchtitle("Mechanics");
        })
        .catch((error) => {
          console.error("Error searching mechanics:", error);
          setdisplay(false);
        });
    };

    if (latitude && longitude) {
      doSearch(latitude, longitude);
    } else if (navigator.geolocation) {
      // No address entered — use browser GPS for proximity ordering
      navigator.geolocation.getCurrentPosition(
        (pos) => doSearch(pos.coords.latitude, pos.coords.longitude),
        () => doSearch(null, null) // permission denied — search without coords
      );
    } else {
      doSearch(null, null);
    }
  };

  const searchTowTrucks = (capacity, address, latitude, longitude) => {
    setdisplay(true);
    setCoordinates({
      lat: longitude,
      lng: latitude,
    });
    //https://dashboard.maineautoparts.com/api/mechanics
    axios
      .post("https://dashboard.maineautoparts.com/api/towtrucks", {
        capacity,
        address,
        latitude,
        longitude,
      })
      .then((response) => {
        let ads = response.data.data;
        setSearchedTowTrucks(ads);
        setdisplay(false);
        setsearchtitle("Tow Trucks");

      })
      .catch((error) => {
        console.error("Error searching tow Trucks:", error);
        setdisplay(false);
      });
  };

  const formatNumber = (num) => {
    if (num != undefined) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  };
  const favourite = (id) => {
    let user = localStorage.getItem("xompsmpsnd101010299msiknsloa11292nsinsi");
    user = JSON.parse(user);
    if (user == null) {
      return false;
    }
    axios
      .put(
        "https://dashboard.maineautoparts.com/api/favourite/" + id,
        {},
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      )
      .then(() => {
        getFavourites();
      })
      .catch((error) => console.log(error));
  };
  const getFavourites = () => {
    let user = localStorage.getItem("xompsmpsnd101010299msiknsloa11292nsinsi");
    user = JSON.parse(user);
    if (user == null) {
      return false;
    }
    axios({
      method: "get",
      url: "https://dashboard.maineautoparts.com/api/allFavourites",
      headers: {
        Authorization: `Bearer ${user.accessToken}`,
      },
    }).then((response) => {
      let ads = response.data.data;
      setFavourites(ads);
    });
  };

  return (
    <AppContext.Provider
      value={{
        categories,
        topCategories,
        brands,
        conditions,
        searchAds,
        searchedAdverts,
        formatNumber,
        favourite,
        favourites,
        getFavourites,
        display,
        searchtitle,
        setReset,
        reset,
        reload,
        setReload,
        searchMechanics,
        searchedMechanics,
        searchTowTrucks,
        setSearchedTowTrucks,
        searchedTowTrucks,
        coordinates,
        setCoordinates,
        specialties,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
